<template>
  <v-row v-if="inscricao && pessoa">
    <template>
      <v-col
        v-for="protocolo in 2"
        class="pa-0 d-flex flex-wrap"
        cols="12"
        :key="`${protocolo}_protocolo`"
      >
        <v-col cols="12" class="text-center py-0">
          <span class="font-weight-bold"
            >PROTOCOLO DE ENCAMINHAMENTO - PLANTÃO DE FÉRIAS
            {{ inscricao.processoPlantao.ano }}</span
          >
        </v-col>

        <v-col cols="12" class="py-0">
          CEI (de origem): {{ inscricao.matricula.unidadeEnsino.nomeCompleto }}
        </v-col>

        <v-col cols="12" class="py-0">
          CEI (onde frequentará o plantão de férias):
          {{ inscricao.unidadeDestino.nomeCompleto }}
        </v-col>

        <v-col cols="6" class="py-0">
          Turma que frequentará:
          {{ inscricao.matricula.etapa.nome }}
        </v-col>

        <v-col cols="6" class="py-0">
          N° Protocolo:
          {{ inscricao.protocolo }}
        </v-col>

        <v-col cols="6" class="py-0">
          Nome: {{ inscricao.matricula.pessoa.nome.toUpperCase() }}
        </v-col>

        <v-col cols="6" class="py-0">
          Data de nascimento:
          {{
            format(
              parseISO(inscricao.matricula.pessoa.data_nascimento),
              "dd/MM/yyyy"
            )
          }}
        </v-col>

        <v-col cols="12" class="py-0">
          Responsável:
          {{ pessoa.nomeMae.toUpperCase() }}
        </v-col>

        <v-col cols="6" class="py-0"
          >Rua: {{ inscricao.matricula.pessoa.endereco.logradouro }}</v-col
        >

        <v-col cols="6" class="py-0"
          >N°: {{ inscricao.matricula.pessoa.endereco.numero }}</v-col
        >

        <v-col cols="6" class="py-0"
          >Bairro:
          {{ inscricao.matricula.pessoa.endereco.bairro }}
        </v-col>

        <v-col cols="6" class="py-0"
          >Cidade: {{ inscricao.matricula.pessoa.endereco.cidade.nome }}</v-col
        >

        <v-row v-if="pessoa.telefones && pessoa.telefones.length" class="ma-0">
          <v-col
            cols="6"
            v-for="tel in pessoa.telefones"
            :key="tel.id"
            class="py-0"
          >
            {{ tel.descricao }}: {{ phoneMask(tel.numero) }}
            <span v-if="tel.falarCom">({{ tel.falarCom }})</span>
          </v-col>
        </v-row>

        <v-row v-else class="ma-0">
          <v-col cols="12" class="pb-0"
            >Telefone Residencial/Comercial:
            ____________________________________</v-col
          >
          <v-col cols="12"
            >Telefone do Trabalho: ____________________________________</v-col
          >
        </v-row>

        <v-col cols="12" class="text-justify">
          Senhor(a) diretor(a): A criança somente poderá receber atendimento
          neste Centro de Educação Infantil se os pais e/ou responsáveis
          apresentarem este protocolo assinado pela direção contendo o carimbo
          do Centro de Educação Infantil de origem.
          <span class="font-weight-bold text-body-1 text-uppercase"
            >Importante:
          </span>
          <span class="text-decoration-underline"
            >NÃO MATRICULAR NENHUMA CRIANÇA SEM ESTE DOCUMENTO.</span
          >
          (anexar este documento à ficha de matrícula do Plantão de Férias -
          {{ inscricao.processoPlantao.ano }}).
        </v-col>

        <v-col cols="6" class="py-0">
          <v-col cols="12" class="text-center pb-0">
            ____________________________________
          </v-col>
          <v-col cols="12" class="text-center py-0">
            Assinatura do Responsável
          </v-col>
        </v-col>
        <v-col cols="6" class="py-0">
          <v-col cols="12" class="text-center pb-0">
            ____________________________________
          </v-col>
          <v-col cols="12" class="text-center py-0">
            Assinatura do Diretor/Secretário
          </v-col>
        </v-col>

        <v-col cols="12" class="text-end pa-0">
          Data:
          {{ format(parseISO(inscricao.data_cadastro), "dd/MM/yyyy HH:mm") }}
        </v-col>

        <v-col
          v-if="protocolo === 1"
          cols="12"
          class="d-flex flex-wrap align-center pa-0"
        >
          <v-col cols="auto">
            <v-icon>
              mdi-content-cut
            </v-icon>
          </v-col>

          <v-col>
            <v-divider class="grey" />
          </v-col>
        </v-col>
      </v-col>
    </template>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          id="cvi-print-btn"
          bottom
          class="mr-8 mb-8"
          color="primary"
          dark
          fab
          fixed
          large
          right
          v-on="on"
          @click="print"
        >
          <v-icon>mdi-printer</v-icon>
        </v-btn>
      </template>
      Imprimir Termo
    </v-tooltip>
  </v-row>
</template>

<script>
import { format, parseISO } from "date-fns";

export default {
  name: "imprimir-encaminhamento-plantao",

  props: {
    id: [Number, String],
  },

  data: () => ({
    inscricao: null,
    pessoa: null,
  }),

  mounted() {
    this.getInscricao();
  },

  methods: {
    async getInscricao() {
      this.inscricao = await this.$http
        .get(`plantao-ferias/${this.id}`)
        .catch((error) => this.showMessage(error, "error"));

      if (!this.inscricao) return;

      this.pessoa = await this.$erudio
        .get(`pessoas/${this.inscricao.matricula.pessoa.id}`)
        .catch((error) => this.showMessage(error, "error"));

      setTimeout(this.print, 100);
    },

    phoneMask(value) {
      if (!value) return "";
      value = value.replace(/\D/g, "");
      value = value.replace(/(\d{2})(\d)/, "($1) $2");
      value = value.replace(/(\d)(\d{4})$/, "$1-$2");
      return value;
    },

    print() {
      const appbar = document.querySelector("#app-bar");
      const printBtn = document.querySelector("#cvi-print-btn");

      window.addEventListener("beforeprint", () => {
        appbar.style.display = "none";
        printBtn.style.display = "none";
      });

      window.addEventListener("afterprint", () => {
        appbar.style.display = "inline";
        printBtn.style.display = "inline";
      });

      // Workaround para trocar o <title> do documento
      window.document.title = "Encaminhamento - Plantão de Férias";

      window.print();

      // Workaround para trocar o <title> do documento
      window.document.title = "Cadastro - Vaga Integral";
    },

    format,
    parseISO,
  },
};
</script>
